export default __webpack_public_path__ + "static/media/tri-4.2a4bd411.svg";